import { API_BASE_URL } from "../Api/baseurl";

const PRIVATE_PATH = /^\/(funds|aligned|dicom|Image_Medical_License|profile|Logo|heatmaps)\//;

// Resolve only known file routes on our API; never send login tokens elsewhere.
export function privateMediaUrl(source) {
  if (!source || typeof source !== "string") return null;
  try {
    const base = new URL(API_BASE_URL, window.location.origin);
    const prefix = base.pathname.replace(/\/+$/, "");
    const target = new URL(source, base.href.replace(/\/+$/, "") + "/");
    if (target.origin !== base.origin || target.username || target.password) return null;
    if (prefix && PRIVATE_PATH.test(target.pathname)) target.pathname = prefix + target.pathname;
    if (!target.pathname.startsWith(prefix + "/")) return null;
    return PRIVATE_PATH.test(target.pathname.slice(prefix.length)) ? target.href : null;
  } catch {
    return null;
  }
}

export function isPrivateMedia(source) {
  return privateMediaUrl(source) !== null;
}

export async function fetchPrivateMedia(source, signal) {
  const target = privateMediaUrl(source);
  if (!target) return { url: source, release() {} };
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Please log in to view this file.");
  const response = await fetch(target, {
    headers: { Authorization: `Bearer ${token}` },
    signal,
    redirect: "error",
    cache: "no-store",
  });
  if (!response.ok) throw new Error(response.status === 401
    ? "Your session has expired. Please log in again."
    : "Unable to load this file. Please check your access or try again.");
  if ((response.headers.get("content-type") || "").includes("application/json")) {
    throw new Error("The server returned an error instead of the requested file.");
  }
  const url = URL.createObjectURL(await response.blob());
  return { url, release: () => URL.revokeObjectURL(url) };
}
